import React from 'react';
import './App.css';
import Hero from './Hero';
import CustomNavbar from './Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';





function App() {
  return (
    <div>
      <CustomNavbar />
      <Hero />
      
    </div>
  );
}

export default App;
